import { Component, DestroyRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Group } from '../../../../../core/shared/models/group.model';
import {
  DeleteMemberFromGroup,
  GetMembers,
} from '../../../../../core/shared/actions/members.actions';
import { membersState } from '../../../../../core/shared/states/members.state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Member } from '../../../../../core/shared/models/member.model';
import { MemberModalComponent } from '../../modals/member-modal/member-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
@Component({
  selector: 'app-group-details-list',
  templateUrl: './group-details-list.component.html',
  styleUrls: ['./group-details-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    LoadingSpinnerComponent,
    MatPaginatorModule,
    MatInputModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class GroupDetailsListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly snackbar = inject(SnackbarService);
  public loading = true;
  public edit = true;
  public dataSource = new MatTableDataSource<Member>();
  public displayedColumns = ['memberEmail', 'actions'];
  public paginator!: MatPaginator;
  public sort!: MatSort;
  @Input() public group!: Group;
  @Input() public applicationName!: string;
  public readonly members: Observable<Member[]>;

  constructor(private store: Store, public modalService: NgbModal) {
    this.members = this.store.select(membersState.getMembersList);
  }

  ngOnInit() {
    this.store.dispatch(new GetMembers(this.group.group_name));
    if (!this.group.group_name) {
      this.edit = false;
    }
    this.members.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource.data = data;
      this.loading = false;
    });
  }

  openModal() {
    const modalRef = this.modalService.open(MemberModalComponent, { size: 'lg' });
    modalRef.componentInstance.group = this.group;
    modalRef.componentInstance.applicationName = this.applicationName;
  }

  onDelete(userName: string, groupName: string) {
    this.store.dispatch(new DeleteMemberFromGroup(userName, groupName)).subscribe({
      next: () => this.snackbar.success('Member removed successfully.'),
      error: () => this.snackbar.error('Failed to remove member.'),
    });
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  //search bar
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
